import { ACTION_TYPES } from './ActionTypes';
import { bindActionCreators } from 'redux';
var actions = {
    setState: function (state) { return ({
        type: ACTION_TYPES.ERROR_SET_STATE,
        state: state,
    }); },
    setError: function (error) { return ({
        type: ACTION_TYPES.ERROR_SET_ERROR,
        error: error,
    }); },
};
export default (function (dispatch) { return bindActionCreators(actions, dispatch); });
//# sourceMappingURL=error.js.map